import Instance from "../../../../Axios";

// New Actions for the app

const EditWorkPermitAccountableById =
  (id, ydata, toggleDrawer, ShowNotification, message, errorMessage) =>
  async (dispatch) => {
    await Instance()
      .put(`/construcoes/workpermits/accountable/${id}`, { ydata })
      .then(({ data }) => {
        // console.log(data);
        dispatch({
          type: "EDIT_WORK_PERMIT_ACCOUNTABLE_ID",
          payload: data.yData[0],
        });
        toggleDrawer("right", false);
        dispatch(ShowNotification(message));
      })
      .catch((err) => {
        console.log(err);
      });
  };

export default EditWorkPermitAccountableById;
